import { StyleSheet } from 'aphrodite';
import { warningDark } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		width: 870,
		textAlign: 'center',
	},
	closeButton: {
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: 28,
	},
	detail: {
		fontSize: 14,
		marginTop: 16,
	},
	header: {
		textAlign: 'center',
	},
	icon: {
		position: 'relative',
	},
	iconSpinner: {
		left: '50%',
		position: 'absolute',
		top: 30,
		transform: 'translateX(-50%)',
	},
	iconSuccess: {
		height: 38,
		width: 38,
	},
	message: {
		fontSize: 18,
		marginTop: 16,
	},
	warnings: {
		color: warningDark,
		fontSize: 14,
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: 16,
		maxWidth: 640,
		textAlign: 'left',
	},
	warningItem: {
		marginTop: 4,
	},
});
